import React, { createContext, useEffect, useState } from "react";

export const SearchContext = createContext(undefined);

// This context provider is passed to any component requiring the context
export const SearchContextProvider = ({ children }) => {
  let [associatedDetails, setAssociatedDetails] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <SearchContext.Provider
      value={{
        associatedDetails,
        setAssociatedDetails,
        searchQuery,
        setSearchQuery,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
